<template>
  <div>
    <div>
      <div class="title">
        直近性
      </div>
      <blockquote class="blockquote">
        提案商品を顧客が購入可能である可能性が高いかの判定方法を選択します。
        <br />
        「考慮なし」以外を選択した場合は、対象とする期間も合わせて指定します。デフォルトでは直近1週間が選択されています。
      </blockquote>
      <div>
        <div>
          <md-radio v-model="_recency" :value="null">考慮なし</md-radio>
        </div>
        <div>
          <md-radio v-model="_recency" value="purchase">
            顧客販売
            <gl-sub-text>
              （顧客が最近買った商品のみ対象とします）
            </gl-sub-text>
          </md-radio>
        </div>
        <div>
          <md-radio v-model="_recency" value="store">
            利用店舗販売
            <gl-sub-text>
              （会員が最後に買い物をした店舗で最近購入されている商品を対象にします）
            </gl-sub-text>
          </md-radio>
        </div>
      </div>
      <div v-if="_recency">
        <div class="flex">
          <div>
            <gl-input-date
              :min="dateFrom"
              :max="dateTo"
              :value.sync="_existsStockFromDate"
            />
          </div>
          <div style="flex: 1;">
            〜 分析期間の終わりまで
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="title">
        提案商品数
      </div>
      <blockquote class="blockquote">
        提案商品数の指定は現在{{ fixedItemsCount }}個固定です。
      </blockquote>
      <div>{{ fixedItemsCount }}個</div>
    </div>
    <div>
      <div class="title">
        固定商品
      </div>
      <blockquote class="blockquote">
        クーポン提案の組み合わせがない場合提案する商品を指定します。
      </blockquote>
      <div>
        <md-field>
          <md-textarea
            v-model="fixedItemsInput"
            placeholder="商品コードを改行区切りで入力してください"
          ></md-textarea>
        </md-field>
      </div>
    </div>
    <div>
      <div class="title">
        前回提案ファイル
      </div>
      <div>
        <file-upload
          :file-load-function="loadPreviousRecommend"
          @loaded="onPreviousRecommendLoaded"
        />
      </div>
    </div>
    <div>
      <div class="title">
        提案順
      </div>
      <blockquote class="blockquote">
        提案商品の判定基準の優先順位を指定します。
      </blockquote>
      <div>
        <ol class="order-selectable-list">
          <li
            class="order-selectable-list__item"
            v-for="(r, i) in recommendOrder"
            :key="r.value"
          >
            <span
              class="order-selectable-list__arrow"
              @click="moveRecommendOrder('up', i)"
            >
              ↑
            </span>
            <span
              class="order-selectable-list__arrow"
              @click="moveRecommendOrder('down', i)"
            >
              ↓
            </span>

            {{ r.label }}
          </li>
        </ol>
      </div>
    </div>
    <div>
      <div class="title">
        提案商品分類ダブり回避
      </div>
      <blockquote class="blockquote">
        提案商品が被らないようにする分類階層を選択します。
        選択した分類階層（e.g.中分類）で異なる分類の商品を提案します。
      </blockquote>
      <div>
        <md-radio :value="null" v-model="_categoryRedundant">
          なし
        </md-radio>
        <md-radio
          v-for="level in itemCategoryLevels"
          :value="level.level"
          v-model="_categoryRedundant"
          :key="level.level"
        >
          {{ level.name }}
        </md-radio>
      </div>
    </div>
    <div>
      <div class="title">
        出力ファイルの囲み文字
      </div>
      <div>
        <md-radio class="content" v-model="_enclosure" :value="null">
          なし
        </md-radio>
        <md-radio class="content" v-model="_enclosure" value="doublequote">
          ダブルクオーテーション
        </md-radio>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'
import FileUpload from '@/components/common/FileUpload.vue'
import GlInputDate from '@/components/common/GlInputDate.vue'
import { getStartDateByWeekCount } from '@/util/date'

const FIXED_ITEMS_COUNT = 2

export default {
  mixins: [ErrorReport],
  components: { FileUpload, GlInputDate },
  props: {
    // 直近性考慮
    recency: {
      type: String,
    },
    // 直近性考慮期間
    existsStockFromDate: {
      type: String,
      validator(value) {
        const regex = new RegExp(/^\d{8}$/g)
        return regex.test(value)
      },
    },
    // 固定商品
    fixedItems: {
      type: Array,
      default: () => [],
    },
    // 提案順
    recommendOrder: {
      type: Array,
      default: () => [],
    },
    // 分類階層
    itemCategoryLevels: {
      type: Array,
      default: () => [],
    },
    // 分類ダブり回避
    categoryRedundant: {
      type: Number,
      default: () => null,
    },
    // 出力ファイルの囲み文字
    enclosure: {
      type: String,
      default: null,
    },
    // 分析期間開始日
    // 直近性考慮期間の範囲を絞るために必要です
    dateFrom: {
      type: String,
      validator(value) {
        const regex = new RegExp(/^\d{8}$/g)
        return regex.test(value)
      },
    },
    // 分析期間終了日
    // 直近性考慮期間の範囲を絞るために必要です
    dateTo: {
      type: String,
      validator(value) {
        const regex = new RegExp(/^\d{8}$/g)
        return regex.test(value)
      },
    },
  },
  data() {
    return {
      loadPreviousRecommend: async id => {
        const repo = this.$repositories.get('uploadFile')
        const result = await repo.loadFile(id, [
          { name: 'card_id', type: 'STRING' },
          { name: 'org_item_code', type: 'STRING' },
          { name: 'org_item_code2', type: 'STRING' },
        ])
        return result
      },
    }
  },
  computed: {
    fixedItemsCount() {
      return FIXED_ITEMS_COUNT
    },
    _recency: {
      get() {
        return this.recency
      },
      set(newVal) {
        this.$emit('update:recency', newVal)
      },
    },
    _existsStockFromDate: {
      get() {
        return this.existsStockFromDate
      },
      set(newVal) {
        this.$emit('update:existsStockFromDate', newVal)
      },
    },
    // 固定商品入力値
    fixedItemsInput: {
      get() {
        return this.fixedItems.join('\n')
      },
      set(value) {
        this.$emit(
          'update:fixedItems',
          value
            .split('\n')
            .map(v => v.trim())
            .filter(v => !!v),
        )
      },
    },
    _categoryRedundant: {
      get() {
        return this.categoryRedundant
      },
      set(newVal) {
        this.$emit('update:categoryRedundant', newVal)
      },
    },
    _enclosure: {
      get() {
        return this.enclosure
      },
      set(newVal) {
        this.$emit('update:enclosure', newVal)
      },
    },
    /**
     * 入力エラー
     */
    errors() {
      const errors = []

      if (this.fixedItems.length != this.fixedItemsCount) {
        errors.push(`固定商品を${this.fixedItemsCount}商品入力してください。`)
      }

      return errors
    },
  },
  watch: {
    recency(newValue, oldValue) {
      if (!oldValue && newValue) {
        // 直近性考慮が「考慮なし」からあり（考慮なし以外）になる
        // タイミングで分析終了期間の1週間前を直近性考慮期間に設定します。
        // 都度リセットされてしまうのはうざいかもしれませんが、どのタイミング
        // が「初期値」かとトリガーが難しいので毎回やってしまいます。
        this.$emit(
          'update:existsStockFromDate',
          getStartDateByWeekCount(this.dateTo, 1),
        )
      }
    },
  },
  methods: {
    moveRecommendOrder(direction, currentIndex) {
      const newIndex =
        direction === 'up'
          ? currentIndex - 1 < 0
            ? 0
            : currentIndex - 1
          : currentIndex + 1

      const itemToMove = { ...this.recommendOrder[currentIndex] }
      const copy = this.recommendOrder.map(r => ({ ...r }))

      copy.splice(currentIndex, 1)
      copy.splice(newIndex, 0, itemToMove)

      this.$emit('update:recommendOrder', copy)
    },
    onPreviousRecommendLoaded(e) {
      this.$emit('previous-recommend', e.loadResult.table.name)
      this.$emit('previous-recommend-filename', e.filename)
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: var(--spacing-large);
  font-size: var(--font-size-large);
}

.md-radio:not(.content) {
  margin-top: 0;
}

.order-selectable-list {
  &__arrow {
    cursor: pointer;
    display: inline-block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border: 1px solid var(--color-border);
  }
}

.flex {
  display: flex;
  align-items: center;
}
</style>
